import { DataService } from '../../data.service';
import { HttpClient } from '@angular/common/http';
import { Universitat } from '../model/Universitat';
import { Pais } from '../model/pais';
import { Alumne } from '../model/alumne';
import { Estudi } from '../model/estudi';
import { Utilitats } from '../utilitats';
import { Injectable } from '@angular/core';

@Injectable()
export class BLEstudi {

    constructor(
        private dataService: DataService,
        private http: HttpClient,
        private utilitats: Utilitats,
        ) {}

    list(pais: Pais, universitat: Universitat, alumne: Alumne, language: string): Promise<Estudi[]> {

        let url = 'estudi?';
        if (pais.value) {
            url += 'pais=' + pais.value;
        }
        if (universitat != null && universitat.value) {
            url += '&universitat=' + universitat.value;
        }
        if (!alumne.isnew) {
            url += '&alumne=' + alumne.id.toString();
        }
        url += '&language=' + language;

        return new Promise<Estudi[]>((resolve, reject) => {
            this.http.get<Estudi[]>(this.dataService.getApiEndpoint(url)).subscribe(data => {
                resolve(data);
            });
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/lib/bl/blestudi.ts